import { createSelector, createSlice } from "@reduxjs/toolkit";

const initialState = {
  userPermissions: [],
  isAuthLoaded: false,
};

const name = "access";
const parentSelector = (state) => state?.[name];

const accessSlice = createSlice({
  name: name,
  initialState: initialState,
  reducers: {
    resetAccess: () => {
      return initialState
    },
    setUserPermissions: (state, action) => {
      return {
        ...state,
        userPermissions: action.payload,
      };
    },
    setIsAuthLoaded: (state, action) => {
      return {
        ...state,
        isAuthLoaded: action.payload,
      };
    }

  },
});


const getUserPermissions = createSelector(parentSelector, (state) => {
  return state?.userPermissions;
});

const getIsAuthLoaded = createSelector(parentSelector, (state) => {
  return state?.isAuthLoaded;
});


const actions = {
  ...accessSlice.actions,
};

const selectors = {
  getUserPermissions,
  getIsAuthLoaded

};

export const accessActions = { actions, selectors };

export default accessSlice;
